import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VCard,{attrs:{"flat":""}},[_c(VRow,{staticClass:"px-4",attrs:{"no-gutters":""}},[_c(VCol,{staticClass:"px-3",attrs:{"cols":"12","sm":12}},[_c('WBDLaborerListFilterComponent',{attrs:{"proceed-filter":_vm.proceedFilter,"remote-option-value":_vm.institutionStaffFilterSet.searchQuery || '',"label":'Поиск соискателей по номеру телефона'},on:{"onSearchQueryFilterChange":_vm.onLaborerSelectorFilterChange}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }